import { useState, useEffect, useRef } from "react";
import Config from "../Config";


import download from "../download.png";


function InputDownloader(props)
{

    const [fileType, setFileType] = useState(props.fileType);
    const [link, setLink] = useState(props.link);
    const [title, setTitle] = useState(props.title);
    const [cls, setCls] = useState(props.className);

    const[status, setStatus] = useState(0);  //1-start downloading //2-finish downloading
    const[stream, setStream] = useState("");

   const refLink = useRef(0);


    const startDownload = () => {
        setStatus(1);
        getData();
    }


    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch(  link, {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                          
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                     // var decodedString = atob(res.result.b64);

                     

                      setStream(res.result.b64);
                      setFileType(res.result.type);
                      setStatus(2);
                    }
         } )     
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    if(status == 1)
    {
        return (
            <span className={cls}>
                ...
            </span>
        )  
    }




        if(status == 2 && stream.length > 10)
        {              

            setTimeout( ()=>{

                //alert(1);
                refLink.current.click();
                setStream(0);

            }, 100 );

                        if(fileType == 'pdf') 
                        {
                            return (
                                <span className={cls}>
                                    <a href={"data:application/pdf;base64," + stream} download={ "download." + fileType } ref={refLink} >otwórz</a>
                                </span>
                            ) 
                        }

                    
                        
                            return (
                                <span className={cls}>
                                    <a href={"data:;base64," + stream} download={ "download." + fileType } ref={refLink} >otwórz</a>
                                </span>
                            ) 
                        
        }   

    return (
        <span className={cls} onClick={startDownload}>
           <img src={download} className="download" /> {title}
        </span>
    )
}


export default InputDownloader;